

const checkForAppUpdates = async () => {
    return;
}

export default checkForAppUpdates